import React from 'react';
import s from '../../PromoBadge.scss';

export interface Props {
  className?: string;
}

const HexagonUnlocked32: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    width="32"
    height="32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.1"
      d="M15 .577a2 2 0 0 1 2 0l11.856 6.846a2 2 0 0 1 1 1.732v13.69a2 2 0 0 1-1 1.732L17 31.423a2 2 0 0 1-2 0L3.144 24.577a2 2 0 0 1-1-1.732V9.155a2 2 0 0 1 1-1.732L15 .577Z"
      className={s['fill-color']}
    />
    <path
      opacity="0.1"
      d="M15 3.577a2 2 0 0 1 2 0l9.258 5.346a2 2 0 0 1 1 1.732v10.69a2 2 0 0 1-1 1.732L17 28.423a2 2 0 0 1-2 0l-9.258-5.346a2 2 0 0 1-1-1.732v-10.69a2 2 0 0 1 1-1.732L15 3.577Z"
      className={s['fill-color']}
    />
    <path
      d="M15 6.577a2 2 0 0 1 2 0l6.66 3.846a2 2 0 0 1 1 1.732v7.69a2 2 0 0 1-1 1.732L17 25.423a2 2 0 0 1-2 0l-6.66-3.846a2 2 0 0 1-1-1.732v-7.69a2 2 0 0 1 1-1.732L15 6.577Z"
      className={s['fill-color']}
    />
  </svg>
);
HexagonUnlocked32.displayName = 'HexagonUnlocked32';

export default HexagonUnlocked32;
